import Vue from 'vue';
// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'mutations' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').FormTemplate} FormTemplate
 */

/**
 * @param {State} state
 * @param {FormTemplate[]} obj
 */
export function setTemplates (state, obj) {
  state.templates = obj || [];
}

/**
 * @param {State} state
 * @param {Object} obj
 * @param {boolean} [obj.upsert=true]
 * @param {FormTemplate[]} obj.items
 */
export function updateInTemplates (state, obj) {
  const { items, upsert } = obj;
  const list = state.templates;
  items.forEach(item => {
    // find existing
    const index = list.findIndex(i => i.id === item.id);

    // update existing (inherit patient details)
    if (~index) {
      item = { ...item };
      item.patient = item.patient || list[index].patient;
      return Vue.set(list, index, item);
    }

    // add to list
    if (upsert) list.push(item);
  });
}
